import React, { FC, useRef, useState } from 'react';
import _ from 'lodash';
import { addComma } from 'src/utils/common';
import { dateFormat } from 'src/utils/dateSet';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import { contentModalViewStore } from 'src/store/modal';
import CreditCardDiv from 'src/components/organisms/template/StepC/template/TaxModal/CreditCard';
import HousingDiv from 'src/components/organisms/template/StepC/template/TaxModal/HousingDiv';
import EtcInputDiv from 'src/components/organisms/template/StepC/template/TaxModal/EtcInputDiv';
import NatinalPensionGrid from 'src/components/molecules/table/NatinalPension';
import InsurfreeGrid from 'src/components/molecules/table/Insurfree';
import MedicalExpenses from 'src/components/molecules/table/MedicalExpenses';
import Education from 'src/components/molecules/table/Education';
import Donation from 'src/components/molecules/table/Donation';
// import HousingDeduction from 'src/components/molecules/table/HousingDeduction';
import PensionSavings from 'src/components/molecules/table/PensionSavings';

const modalContent = (id: string, type: string, selectObj: any) => {
  // const selectObj = gridData.find((item: any) => item.id === id);
  switch (id) {
    case 'insurance_health_pension':
      return {
        active: '_active',
        title: selectObj.category || '국민연금/건강보험료(추가납부) 상세',
        content: <NatinalPensionGrid type={type} />,
        styleDef: { width: '1024px' },
      };
    case 'insurance':
      return {
        active: '_active',
        title: selectObj.category || '보험료 상세',
        content: <InsurfreeGrid type={type} />,
        styleDef: { width: '1024px' },
      };
    case 'medical':
      return {
        active: '_active',
        title: selectObj.category || '의료비 상세',
        content: <MedicalExpenses type={type} />,
        styleDef: { width: '1024px' },
      };
    case 'education':
      return {
        active: '_active',
        title: selectObj.category || '교육비 상세',
        content: <Education type={type} />,
        styleDef: { width: '1024px' },
      };
    case 'donation':
      return {
        active: '_active',
        title: selectObj.category || '기부금 상세',
        content: <Donation type={type} />,
        styleDef: { width: '1024px' },
      };
    case 'housing':
      return {
        active: '_active',
        title: selectObj.category || '주택자금 상세',
        content: <HousingDiv type={type} />,
        styleDef: { width: '1024px' },
      };
    case 'pension_savings':
      return {
        active: '_active',
        title: selectObj.category || '연금저축등 상세',
        content: <PensionSavings type={type} />,
        styleDef: { width: '1024px' },
      };
    case 'others':
      return {
        active: '_active',
        title: selectObj.category || '기타입력 상세',
        content: <EtcInputDiv type={type} />,
        styleDef: { width: '1024px' },
      };
    default:
      return {
        active: '_active',
        title: selectObj.category || '신용카드 외 상세',
        content: <CreditCardDiv type={type} />,
        styleDef: { width: '1024px' },
      };
  }
};

export const gridFnc = {
  priceContent: (param: any) => {
    const clickEvt = (e: any) => {};
    const count = param || 0;

    return (
      <div className="_custom_div_right_t2">
        <div className="_txt">
          {addComma(count)}
          <em className="_ft_px_t1">원</em>
        </div>
      </div>
    );
  },

  priceContentT2: (param: any) => {
    const clickEvt = (e: any) => {};
    const count = param || 0;

    return (
      <div className="_custom_div_right_t3">
        <div className="_txt">
          {addComma(count)}
          <em className="_ft_px_t1">원</em>
        </div>
      </div>
    );
  },
  createDate: (param: any) => {
    return dateFormat(param[0], 'YYYY.MM.DD HH:mm');
  },
  viewCount: (param: any) => {
    const count = param[0] || 0;
    return addComma(count);
  },
  title: (param: any) => {
    const str = param || '';
    return str;
  },
  detailFn: (item: any, setContentModalState: any) => {
    const id = item.id || '';
    // const setContentModalState = contentModalViewStore((state: any) => state.set);

    const clickEvt = (e: any, rId: string) => {
      const payload = modalContent(rId, 'list', item);
      setContentModalState(payload);
    };

    return (
      <div className="_btn_div">
        <div className="_r_btn">
          <DefaultButton
            text="상세"
            clickEvent={e => clickEvt(e, id)}
            icon="ri-file-text-line"
            type="type2"
            styleDef={{ height: '23px', fontSize: '12px', lineHeight: '12px', width: '60px' }}
          />
        </div>
      </div>
    );
  },
};

export const gridOptionSet = {
  label: [
    {
      label: '구분',
      col: 'category',
      width: 'calc(100% - 550px)',
      align: 'left',
      sort: { use: false, active: false, status: 'desc' },
      style: { fontSize: '13px' },
      custom: 'title',
      // custom: { fn: gridFnc.gridName, param: ['category', 'id'] },
    },
    {
      label: '국세청 PDF 금액',
      col: 'nts_amt',
      width: '200px',
      align: 'right',
      sort: { use: false, active: false, status: 'desc' },
      custom: 'priceContent',
      // custom: { fn: gridFnc.priceContent, param: ['nts_amt', 'id'] },
    },
    {
      label: 'PDF 적용금액',
      col: 'import_amt',
      width: '200px',
      align: 'right',
      sort: { use: false, active: true, status: 'desc' },
      custom: 'priceContent',
      // custom: { fn: gridFnc.priceContentT2, param: ['manual_amt', 'id'] },
    },
    {
      label: '수기 입력금액',
      col: 'manual_amt',
      width: '200px',
      align: 'right',
      sort: { use: false, active: true, status: 'desc' },
      custom: 'priceContent',
      // custom: { fn: gridFnc.priceContentT3, param: ['manual_amt', 'id'] },
    },
    {
      label: '공제요건 충족금액',
      col: 'eligible_amt',
      width: '200px',
      align: 'right',
      sort: { use: false, active: true, status: 'desc' },
      custom: 'priceContentT2',
      // custom: { fn: gridFnc.priceContentT3, param: ['eligible_amt', 'id'] },
    },
    {
      label: '상세',
      col: 'applyAccount',
      width: '100px',
      align: 'center',
      sort: { use: false, active: true, status: 'desc' },
      custom: 'detail_btn',
      // custom: { fn: gridFnc.detailFn, param: ['id'] },
    },
  ],
};
